export const DEFAULT_UNITS_QUERY = "/portal/v1/units";

export const statuses = [
  { value: false, label: "Available" },
  { value: true, label: "Occupied" }
];

export const unitStatus = (occupied: boolean) =>
  occupied ? "Occupied" : "Available";
